import React, { createContext, useEffect, useState } from 'react';
import { Button, Checkbox } from 'antd';
import SectionRight from './SectionRight/SectionRight';
import calendarPng from 'assets/images/calendar.png';
import closePng from 'assets/images/close-gray.png';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { TaskState } from '../../../../gql/graphql';
import { Tooltip } from 'react-tooltip';
import ProcessingTeamImpersonationBar, { useIsImpersonating } from 'components/Atoms/Bars/ProcessingTeamImpersonationBar/ProcessingTeamImpersonationBar';
import { getBubbleConfig, isStepDisabled } from '@common/utils/helpers/bubbleConfig';

interface Props {
  visible: boolean;
  handlerSetVisibile: Function;
  renderButtonTrigger: Function;
  header?: {
    title: React.ReactElement;
    actionLeft?: React.ReactElement;
    actionRight?: React.ReactElement;
  };
  stepsTotal: number | 1;
  currentStep: number;
  setStep: Function | null;
  children: React.ReactElement;
  footer?: React.ReactElement | null;
  tracker?: React.ReactElement | null;
  animationDirection: string | 'onRight';
  responses?: any[];
  disabledDots?: boolean;
  isConfirmModalClose?: boolean;
  stepAlwaysDraft?: number;
  stepAlwaysApproved?: number;
  canNavigateToStep?: (targetStep: number) => boolean;
  task?: any;
}
interface dotObject {
  id: number;
  state: string;
}

export const ModalTaskRightContext = createContext<{ value: string; setHandler: any } | {}>({});

const ModalTask = (props: Props) => {

  const [isDots, setDots] = useState<dotObject[]>();
  const [isModalSubmit, setModalSubmit] = useState<string>("inactive");
  const [openSectionRight, setOpenSectionRight] = useState<{ show: boolean, params?: any }>();
  const [isHovered, setIsHovered] = useState<number | null>(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const isDisabledDots = Boolean(props.disabledDots);
  
  const checkStepDisabled = (targetStep: number) => {
    return isStepDisabled(
      targetStep,
      props.currentStep,
      isDisabledDots,
      props.canNavigateToStep
    );
  };

  useEffect(() => {
    const arrayDots: dotObject[] = [];

    for (let index = 0; index < props.stepsTotal; index++) {
      arrayDots.push({ id: index + 1, state: '' });
    }

    // Asignar estados desde las respuestas
    if (props.responses) {
      for (const dot of arrayDots) {
        const responsesStep = props.responses.filter(
          response => response?.step === dot.id
        );

        if (responsesStep?.length > 0) {
          const isApproved = responsesStep.every((item: any) => item.state === TaskState.Approved);
          const isError = !!responsesStep.find(
            (item: any) => item.state === TaskState.RequestError
          );
          const isReview = !!responsesStep.find(
            (item: any) => item.state === TaskState.Review
          );
          const isDraft = responsesStep.every(
            (item: any) => item.state === TaskState.Draft || item.state === TaskState.Incomplete
          );

          // Props especiales que fuerzan estados
          if (props.stepAlwaysDraft === dot.id) {
            dot.state = 'draft';
          } else if (isApproved || props.stepAlwaysApproved === dot.id) {
            dot.state = 'approved';
          } else if (isError) {
            dot.state = 'error';
          } else if (isReview) {
            dot.state = 'review';
          } else if (isDraft) {
            dot.state = 'draft';
          }
        }
      }
      setDots(arrayDots);
    }
  }, [props.responses, props.stepsTotal, props.stepAlwaysDraft, props.stepAlwaysApproved]);

  useEffect(() => {
    document.body.style.overflowY = (props.visible) ? "hidden" : "scroll";
  }, [props.visible])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const closeModal = () => {
    props.handlerSetVisibile(false);
    setOpenSectionRight({ show: false });
    setModalSubmit("inactive");
    /*
    if(localStorage.getItem('modalTaskClose') === 'true') {
      setModalSubmit("close")  
      return;
    }
    
    setModalSubmit(props.isConfirmModalClose ? "active" : "close")*/
  }

  const handlerModalTaskRight = (show: boolean, params: any) =>
    setOpenSectionRight({ show, params });

  const onChangeCheckbox = (e: CheckboxChangeEvent) => {
    if (e.target.checked)
      localStorage.setItem('modalTaskClose', 'true');
    else
      localStorage.removeItem('modalTaskClose');
  };

  useEffect(() => {
    if (isModalSubmit === "close") {
      props.handlerSetVisibile(false);
      setOpenSectionRight({ show: false });
      setModalSubmit("inactive");
    }
  }, [isModalSubmit])

  const handleMouseEnter = (id: number) => setIsHovered(id);
  const handleMouseLeave = () => setIsHovered(null);

  const getBubbleConfiguration = (dot: dotObject) => {
    const isDisabled = checkStepDisabled(dot.id);
    const taskState = props.task?.state;
    const config = getBubbleConfig({
      stepIndex: dot.id,
      currentStep: props.currentStep,
      totalSteps: props.stepsTotal,
      stepState: dot.state,
      taskState: taskState,
      canNavigate: !isDisabled,
      disabledDots: props.disabledDots || false,
      responses: props.responses,
      stepAlwaysDraft: props.stepAlwaysDraft,
      stepAlwaysApproved: props.stepAlwaysApproved
    });

    return {
      ...config,
      isDisabled
    };
  };
  
  const { showProcessingBar }  = useIsImpersonating();

  return (
    <div className="cont-modal">
      {props.renderButtonTrigger(props.handlerSetVisibile)}
      {props.visible && (
        <ModalTaskRightContext.Provider value={{ value: openSectionRight, setHandler: handlerModalTaskRight }}>
          <div className="ModalTask">
            {!openSectionRight?.show &&
              <Button
                className="button-close-mask"
                style={{ width: openSectionRight?.show ? '0%' : '10%' }}
                onClick={closeModal}
              />
            }
            <div
              className={`ModalTask-content animate__animated ${props.animationDirection === 'onRight' && 'animate__fadeInRight'}`}
              style={{ width: openSectionRight?.show ? '80%' : '90%' }}
            >
              {
                showProcessingBar &&
                  <ProcessingTeamImpersonationBar />
              }
              <div className="content-modal">
                <div className="modal-review-task__content">
                  <div className="modal-title">
                    <div className="flex-btw">
                      <h3 className="body-card body-card-w6">
                        {props.header?.title}
                      </h3>
                      <Button
                        className="body-card"
                        onClick={closeModal}
                      >
                        Close X
                      </Button>
                    </div>
                  </div>
                </div>
                <div style={{ display: 'flex' }}>

                  {props.tracker &&
                    <div className='task-tracker-summary' style={{ height: 'default' }}>{props.tracker}</div>
                  }

                  <div
                    className="modal-container"
                    style={{ height: props.tracker ? '90vh' : 'calc(100vh - 180px)' }}
                  >
                    {isDots && (
                      <div className="dots-container">
                      <div className="dots">
                        {isDots.map((dot) => {
                          const bubbleConfig = getBubbleConfiguration(dot);
                          const tooltipId = `tooltip-button-${dot.id}`;

                          return (
                            <React.Fragment key={dot.id}>
                              <Button
                                onMouseEnter={() => handleMouseEnter(dot.id)}
                                onMouseLeave={handleMouseLeave}
                                onClick={() => {
                                  if (bubbleConfig.isClickable && props.setStep) {
                                    props.setStep(dot.id);
                                  }
                                }}
                                disabled={bubbleConfig.isDisabled}
                                className={bubbleConfig.buttonClass}
                                {...(!isMobile && {
                                  'data-tooltip-id': tooltipId,
                                  'data-tooltip-html': bubbleConfig.tooltipText,
                                  'data-tooltip-offset': -5
                                })}
                              />

                              {bubbleConfig.tooltipText && !isMobile && (
                                <Tooltip
                                  id={tooltipId}
                                  place="right"
                                  className={`tooltip-button ${bubbleConfig.tooltipClass}`}
                                />
                              )}
                            </React.Fragment>
                            );
                          })}
                        </div>
                      </div>
                    )}
                    <div className="modal-cards modal-cards--full">
                      <div className="modal-cards-mx-w">
                        <div className="flex-btw">
                          {props.header?.actionLeft}
                          {props.header?.actionRight}
                        </div>
                        {props.children}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {props.footer && (
                <div className="modal-review-task__footer">
                  <div className="modal-container">
                    <div className="modal-cards">{props.footer}</div>
                  </div>
                </div>
              )}
            </div>
            {openSectionRight?.show &&
              <SectionRight params={openSectionRight.params} close={() => setOpenSectionRight({ show: false })} />
            }
            {isModalSubmit === "active" &&
              <div className='ModalCloseTask'>
                <Button className='ModalCloseTask-mask' onClick={() => setModalSubmit("inactive")}></Button>
                <div className="modal-end-submit__content">
                  <Button className='button-close' onClick={() => setModalSubmit("inactive")}>
                    <img src={closePng} alt='close' />
                  </Button>
                  <img className="coin" alt="coin" src={calendarPng} />
                  <h2 className="h2">Finish this task later?</h2>
                  <h4 className="h4 h4-w4 text-modal">Don’t worry! We’ll save your work. Just click on the task in your dashboard to resume.</h4>
                  <div className="buttons">
                    <Button
                      className="button button-modal-ok mt--10"
                      onClick={(e) => {
                        setModalSubmit("close");
                      }}
                    >
                      I’ll do this later
                    </Button>
                    <Button
                      className="button button-modal-cancel"
                      onClick={() => setModalSubmit("inactive")}
                    >
                      I want to finish this task now
                    </Button>
                  </div>
                  <br />
                  <Checkbox onChange={onChangeCheckbox}>Don’t show this message again</Checkbox>
                </div>
              </div >
            }
          </div>
        </ModalTaskRightContext.Provider>
      )}
    </div>
  );
};
export default ModalTask;
